import DayPicker from "react-day-picker";
import './DatePicker.scss';

export const DatePicker = ({ selectedDays, onDayClick, className }) => {
  return (
    <DayPicker
      selectedDays={selectedDays}
      onDayClick={onDayClick}
      className={className}
    />
  );
};
